import {activityPlaces} from '@mep/pae-commons';
import {Form, Select} from 'antd';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

const {ACTIVITY_PLACE_TENANT_TYPES_ENUM} = activityPlaces;

const ActivityPlaceTenantOriginSelect = ({...props}) => {
  const {t} = useTranslation('activityPlace');
  const options = ACTIVITY_PLACE_TENANT_TYPES_ENUM.map((e) => ({value: e, label: t(`origins.${e}`)}));
  
  return (<Select
    showSearch={true}
    filterOption={false}
    allowClear={false}
    {...props}
    placeholder={t('selectPlaceholder')}
    optionFilterProp={'label'}
    options={options}>
  </Select>);
  
};

ActivityPlaceTenantOriginSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

ActivityPlaceTenantOriginSelect.defaultProps = {};

export default memo(ActivityPlaceTenantOriginSelect);

export const renderActivityPlaceTenantOriginSelect = ({formItemProps, field}) => {
  return (
    <Form.Item {...formItemProps} required={field?.required}>
      <ActivityPlaceTenantOriginSelect {...field?.widgetProps} {...field}/>
    </Form.Item>
  );
};
